import { render, staticRenderFns } from "./club-list.vue?vue&type=template&id=08905446&scoped=true"
import script from "./club-list.vue?vue&type=script&lang=js"
export * from "./club-list.vue?vue&type=script&lang=js"
import style0 from "./club-list.vue?vue&type=style&index=0&id=08905446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08905446",
  null
  
)

export default component.exports